import script from "./TagsView.vue?vue&type=script&setup=true&lang=js"
export * from "./TagsView.vue?vue&type=script&setup=true&lang=js"

import "./TagsView.vue?vue&type=style&index=0&id=5729be89&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5729be89"]])

export default __exports__